import { Navigate, useParams } from "react-router-dom";
import { useSite } from "@/context/SiteContext";
import { PageHero, Reveal } from "@/components/site/Reveal";
import { usePageMeta } from "@/lib/seo";

export default function CustomPage() {
  const { slug } = useParams();
  const { content, openJoin } = useSite();
  const page = content.pages.find((p) => p.slug === slug && p.enabled);
  usePageMeta(`${page?.title || "Iron Pump Gym"} | Iron Pump Gym Queens`, page?.body?.slice(0, 150) || "Iron Pump Gym, Bayside & Flushing, Queens.");
  if (!page) return <Navigate to="/" replace />;
  return (
    <>
      <PageHero eyebrow={page.title} title={page.heading || page.title} image="/images/floor.webp" />
      <section className="mx-auto max-w-4xl px-4 py-16 sm:px-8" data-testid="custom-page-body">
        <Reveal className="space-y-4 whitespace-pre-line text-base leading-relaxed text-white/70">{page.body}</Reveal>
        <button onClick={() => openJoin()} className="btn-gold mt-10" data-testid="custom-page-join-btn">Join Now</button>
      </section>
    </>
  );
}
